import { AfterViewInit, Component, OnInit, NgZone, ViewEncapsulation } from '@angular/core';
import { PROJECTS } from '@core/enum/projects.enum';
import { ModalErrorConfig } from '@core/interfaces/modal-error-config.interface';
import { MessageBusService, MicroFrontendRouter } from '@xdig/ng-microkernel/micro-frontend';
import { ModalService } from '../../modal.service';
import {
  SHOW_APPS_CONFIG_FTD,
  URL_APP_DOWNLOAD,
  URL_APP_STORE,
} from './show-apps.component.config';
import { environment } from '@env/environment';
import { MatDialog } from '@angular/material/dialog';
import { DownloadAppQrModalComponent } from '@shared/information/modal/download-app-qr-modal/download-app-qr-modal.component';
import { tap } from 'rxjs';

@Component({
  selector: 'shell-show-apps',
  templateUrl: './show-apps.component.html',
  styleUrls: ['./show-apps.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ShowAppsComponent implements OnInit {
  config: ModalErrorConfig;
  modalError: any;
  urlRedirection: string;
  assetsUrl = environment.assetsUrl;
  urlStore = URL_APP_STORE;

  constructor(
    private modalService: ModalService,
    public microFrontendRouter: MicroFrontendRouter,
    public messageBus: MessageBusService,
    public ngZone: NgZone,
    private dialog: MatDialog,
  ) {}

  closeModal(): void {
    this.urlRedirection = URL_APP_DOWNLOAD;
    window.location.href = this.urlRedirection;
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.ngZone.run(() => {
        this.modalError = this.messageBus.getValue('shell', 'modal.error');
        this.config = SHOW_APPS_CONFIG_FTD;
      });
    });
  }

  openQrModal(urlStore: string) {
    this.messageBus.emit('shell', 'urlToObtailApp', urlStore);
    setTimeout(() => {
      this.dialog.open(DownloadAppQrModalComponent).afterClosed().subscribe();
    }, 200);
  }
}
